import SceneController from 'controllers/sceneController';
import OverviewController
from 'controllers/settings/entityOverviewController';
import LocationsDetailController
from 'controllers/settings/locations/locationsDetailController';
import LocationsPlaceholderController from 'controllers/settings/locations/locationsPlaceholderController';
import * as _ from 'underscore'

class LocationsSceneController extends SceneController {
  show() {
    this.controller = new OverviewController({
      headerLocaleKey: 'webapp.settings.locations.header',
      entityType: 'location_entity',
      prefixSearchErrorLocaleKey: 'webapp.settings.locations.searchErrorNotification',
      knowledgebaseErrorLocaleKey: 'webapp.settings.locations.locationLoadErrorNotification'
    });
    this.showInLeftColumn(this.controller.view);
    this._showPlaceholder();
    this._registerListeners();
  }

  _showPlaceholder() {
    this._closeDetailView();
    this._showDetailController(LocationsPlaceholderController, {});
  }

  _showDetailController(Controller, param) {
    this.detailController = new Controller(param);
    this.detailView = this.detailController.view;
    this.showInRightColumn(this.detailView);
  }

  _closeDetailView() {
    if (!_.isUndefined(this.detailView)) {
      this.detailView.close();
      delete this.detailView;
      this.detailController.close();
      delete this.detailController;
      this.focusRight();
    }
  }

  _registerListeners() {
    this.listenTo(this.controller, 'entity:clicked', this._showLocationDetails);
    this.listenTo(this.controller, 'entity:closed', this._closeDetailView);
  }

  _showLocationDetails(data) {
    this._showDetailController(
      LocationsDetailController,
      { location: data }
    );

  }
}

export default LocationsSceneController;
